  import React from 'react';
  import Card from '@mui/material/Card';
  import Box from '@mui/material/Box';
  import IconButton from '@mui/material/IconButton';
  import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

  const DataCard = (props) => {
    const {title, numColumns, columnData, logoSrc, onMoreClick } = props;

    const columns = columnData?.slice(0, numColumns).map((column, index) => (
      <div
        key={index}
        style={{
          flex: `1 0 calc(50% / ${numColumns})`, 
          border: '1px solid #ccc', // Add border style here
          borderBottom: 'none',
        
          justifyContent: 'flex-start', // Horizontal alignment centered
        //  alignItems: 'center', // Vertical alignment at the top
          paddingTop: '10px',
          paddingLeft:'20px',
          borderTop: '1px solid #E7E7E7',
          height: '90px',
          display: 'flex',
          flexDirection: 'column',
          marginBottom:'5px',
     
        }}
      >
        <div style={{ color: '#131F32', fontSize: '12px', fontWeight: '600' ,marginBottom:'5px'}}>
          {column.header}
        </div>
        <div
          style={{
            color: '#131F32',
            fontSize: '16px',
            fontWeight: '500',
            lineHeight: '20px',
            overflow:'auto',
            
          }}
        >
          {' '}
          {column.data}
        </div>
      </div>
    ));

    return (
      <Card
        style={{
          width: '99%',
          height: '150px',
          borderRadius: '12px',
          marginBottom:'10px',
          border: '1px solid #ccc',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: '10px',
            // marginBottom: '10px',
            // padding:'5px'
          }}
        >
          <Box sx={{ marginLeft: '2%', display: 'flex', flexDirection: 'row' }}>
            {/* <img
              style={{ height: '40px', width: '40px' }}
              src={logoSrc}
              alt="logo"
            /> */}
            <Box
              sx={{
                color: '#131F32',
                fontSize: '20px',
                fontWeight: '600',
                marginLeft: '10px',
                marginTop: '10px',
              }}
            >
              {title}
            </Box>
          </Box>
          <IconButton onClick={onMoreClick} sx={{ marginRight: '10px ' }}>
            <MoreHorizIcon />
          </IconButton>
        </Box>
        {/* <hr /> */}
    
        <div style={{ display: 'flex' }}>{columns}</div>
      </Card>
    );
  };

  export default DataCard;
